export default __webpack_public_path__ + "../staticImages/katalog2-260.png";